import React from 'react'
import Carousel from 'react-bootstrap/Carousel'
import {Jumbotron} from './migration'

const Leadership = ({heading, img, imageSize, message}) => {
    return (
        <Jumbotron
            className="m-0"
            id="leadership"
            style={{backgroundColor: 'white'}}
        >
            <h2 className="display-4 pb-5 text-center">
                {heading}
            </h2>
            <div className="row">
                <div className="col-md-5">
                    <p className="lead">
                        {message}
                    </p>
                </div>
                <div className="col-md-7">
                    <Carousel>
                        {
                            img.map((value, index) => {
                                return (
                                    <Carousel.Item key={index}>
                                        <img
                                            alt="First slide"
                                            className="d-block w-100"
                                            height={imageSize.height}
                                            src={value.img}
                                            width={imageSize.width}
                                        />
                                        <Carousel.Caption>
                                            <h3>{value.label}</h3>
                                            <p>
                                                {value.paragraph}
                                            </p>
                                        </Carousel.Caption>
                                    </Carousel.Item>
                                )
                            })
                        }
                    </Carousel>
                </div>
            </div>
        </Jumbotron>
    )
}

export default Leadership